module.exports = __webpack_public_path__ + "img/203.498c72e9.jpg";